import React, { useCallback, useEffect, useState } from 'react';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { setPbxSectionMounted } from 'flow/actions/app-actions';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { PbxParams } from 'flow/types/Params';
import { SUPERVISOR_VIEW_KEY } from 'flow/selectors/queue-selectors';
import { routes } from 'flow/types/routes';
import SearchBar from '../SearchBar';
import PbxList from './PbxList_TW';

const ENTITY_TYPE_SHARED = 'shared';
const ENTITY_TYPE_EXTENSION = 'extension';

const PbxNavigation = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { entityKey } = useParams<PbxParams>();
    const [filterText, setFilterText] = useState('');

    useEffect(() => {
        dispatch(setPbxSectionMounted(true));
        return () => {
            dispatch(setPbxSectionMounted(false));
        };
    }, [dispatch]);

    const onItemSelected = useCallback(
        (key: string) => {
            const [entityType]: string[] = key.split('-');

            const showPage: Record<string, string> = {
                channel: routes['pbx.channels.entityKey'],
                queue: routes['pbx.queues.entityKey'],
                refer: routes['pbx.refers.entityKey'],
                voicemail: routes['pbx.voicemails.entityKey'],
            };

            if (entityType === ENTITY_TYPE_SHARED) {
                history.push(
                    generatePath(routes['pbx.connections.connectionKey'], {
                        connectionKey: key,
                    }),
                );
            } else if (entityType === ENTITY_TYPE_EXTENSION) {
                history.push(
                    generatePath(routes['pbx.aicoworker.extensionKey'], {
                        extensionKey: key,
                    }),
                );
            } else if (showPage[entityType]) {
                history.push(
                    generatePath(showPage[entityType], {
                        entityKey: key,
                    }),
                );
            } else if (key === SUPERVISOR_VIEW_KEY) {
                history.push(routes['pbx.overview']);
            } else {
                console.warn('Taking no action on: ' + key);
            }
        },
        [history],
    );

    return (
        <div className="flex grow flex-col bg-gray-100">
            <div className="p-3">
                <SearchBar
                    onChange={setFilterText}
                    initialSearchText={filterText}
                />
            </div>

            <div className="h-full ps-3 pb-3">
                <PbxList
                    onItemSelected={onItemSelected}
                    filterText={filterText}
                    selectedPbx={entityKey}
                />
            </div>
        </div>
    );
};

export default PbxNavigation;
